import type { TReviews } from '@shared/common/data/products';
import TokyoMetro from './TokyoMetro';
import LetsMakeMetro from './LetsMakeMetro';

const Books = [TokyoMetro, LetsMakeMetro];

export const tmBookAliasArr = Books.map((_) => _.alias);

export const Reviews = Books.reduce<TReviews>((arr, book) => {
  arr.push(...book.reviews);

  return arr;
}, []);

export default Books;
